import deals from './deals';

export default ({
  namespaced: true,

  modules: {
    deals,
  },
});